import { render } from "./HrEvents.vue?vue&type=template&id=270ab5c8&scoped=true"
import script from "./HrEvents.vue?vue&type=script&lang=js"
export * from "./HrEvents.vue?vue&type=script&lang=js"

import "./HrEvents.vue?vue&type=style&index=0&id=270ab5c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-270ab5c8"]])

export default __exports__